import { gql } from '@apollo/client';

export default gql`
  query bookings($reference: String!) {
    bookings(reference: $reference) {
      reference
      expiryTimestamp
      status
      customer {
        firstName
        lastName
      }
      passengers {
        id
      }
      outbound {
        origin {
          name
        }
        destination {
          name
        }
        timing {
          isoDate
        }
      }
      inbound {
        origin {
          name
        }
        destination {
          name
        }
        timing {
          isoDate
        }
      }
      externalBookingReferences {
        source
        type
        externalId
      }
    }
  }
`;
